import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, MapPin } from "lucide-react";
import { SiteHeader, PageFooter } from "@/components/brand/Brand";
import { CompanyLogo } from "@/components/company/CompanyLogo";
import { useDemo } from "@/lib/demo/store";
import { useI18n } from "@/lib/i18n/i18n";
import { directoryCompanies } from "@/lib/demo/companies";

export default function Empresas() {
  const { state, activeParticipant: p } = useDemo();
  const { t } = useI18n();
  const shared = new Set(state.interactions.filter((i) => i.participantId === p.id).map((i) => i.companyId));

  return (
    <div className="min-h-screen bg-slate-50 pb-28" data-testid="companies-page">
      <SiteHeader />
      <main className="mx-auto max-w-7xl px-5 py-12 lg:px-10 lg:py-16">
        <p className="fade-up text-xs font-bold uppercase tracking-[0.25em] text-upv">{t("Más de 125 empresas en el Foro · selección de demostración")}</p>
        <h1 className="fade-up-1 mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl" data-testid="companies-title">{t("Empresas participantes")}</h1>
        <p className="fade-up-2 mt-4 max-w-2xl text-slate-600">{t("Descubre las empresas y sus oportunidades, y comparte tu currículum antes, durante o después de visitar su stand.")}</p>
        <Link to="/empresas/inscripcion" className="fade-up-2 mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-upv underline-offset-4 hover:underline" data-testid="companies-register-link">{t("Inscripción de empresas")} <ArrowRight className="h-3.5 w-3.5" /></Link>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {directoryCompanies(state).map((c) => (
            <Link key={c.id} to={`/empresas/${c.id}`} className="group overflow-hidden rounded-[28px] border border-slate-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl" data-testid={`company-card-${c.id}`}>
              <div className="relative h-44 overflow-hidden">
                <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                {shared.has(c.id) && (
                  <span className="absolute right-4 top-4 flex items-center gap-1.5 rounded-full bg-emerald-600 px-3 py-1 text-[11px] font-bold text-white" data-testid={`company-card-shared-${c.id}`}><CheckCircle2 className="h-3.5 w-3.5" /> {t("CV compartido")}</span>
                )}
                <div className="absolute bottom-0 left-5 translate-y-1/2 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-md"><CompanyLogo id={c.id} logo={c.logo} size="text-lg" /></div>
              </div>
              <div className="px-6 pb-6 pt-10">
                <p className="font-display text-xl font-bold">{c.name}</p>
                <p className="mt-1 text-sm text-slate-500">{t(c.sector)}</p>
                <div className="mt-5 flex items-center justify-between text-xs font-semibold">
                  <span className="flex items-center gap-1.5 text-slate-500"><MapPin className="h-3.5 w-3.5 text-upv" /> Stand {c.stand}</span>
                  <span className="flex items-center gap-1.5 text-upv">{t("{n} oportunidades", { n: c.jobs.length })} <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <PageFooter />
    </div>
  );
}
